<!-- 首页版块宣传王选奖项列表组件 -->
<template>
  <div class="rewards-block-wrap">    
    <BlockName 
      blockName="纪念奖项"
      url="/xuanchuan?tab=jinianjiangxiang"></BlockName>
    <div class="data-box">
        <div class="left-box" @click="handleItemClick">
            <div class="qn-icon-box">
              <div class="wx-img"></div>
            </div>
            <div class="qn-title">北京大学王选青年学者奖励基金</div>
        </div>
        <div v-if="textMode == true" class="right-box">
          <el-row v-show="awardList.length > 0" :gutter="10">
            <el-col :span="12" v-for="item in awardList" style="margin-bottom: 10px;"
              :key="item.id">
              <div class="reward-item" @click="handleItemClick">
                <div class="title" v-html="item.coverText"></div>
              </div>
            </el-col>
          </el-row>
          
          <!--
          <div class="row">
            <div class="reward-item" @click="handleItemClick">
              <div class="title" v-html="rewardTitles[0]"></div>
            </div>
            <div class="reward-item" @click="handleItemClick">
              <div class="title" v-html="rewardTitles[1]"></div>
            </div>
          </div>
          <div class="row">
            <div class="reward-item" @click="handleItemClick">
              <div class="title" v-html="rewardTitles[2]"></div>
            </div>
            <div class="reward-item" @click="handleItemClick">
              <div class="title" v-html="rewardTitles[3]"></div>
            </div>
          </div>
          -->
        </div>
        <div v-else class="right-box">
            <div class="row">
              <RewardCover
                  v-if="awardList.length > 0"
                  :title="awardList[0].coverText"
                  :titleStyle="titleStyle"
                  goto="/xuanchuan?tab=jinianjiangxiang">
                </RewardCover>
                <RewardCover
                  v-if="awardList.length > 1"
                  :title="awardList[1].coverText"
                  :titleStyle="titleStyle"
                  goto="/xuanchuan?tab=jinianjiangxiang">
              </RewardCover>
            </div>
            <div class="row">
              <RewardCover
                  v-if="awardList.length > 2"
                  :title="awardList[2].coverText"
                  :titleStyle="titleStyle"
                  goto="/xuanchuan?tab=jinianjiangxiang">
                </RewardCover>
                <RewardCover
                  v-if="awardList.length > 3"
                  :title="awardList[3].coverText"
                  :titleStyle="titleStyle"
                  goto="/xuanchuan?tab=jinianjiangxiang">
              </RewardCover>
            </div> 
        </div>
    </div>
  </div>

</template>

<script>
  import BlockName from './blockname.vue';
  import RewardCover from '@/components/basic/rewardcover';
  import { getAwardList } from "@/api/content";
  export default {
    components: { BlockName, RewardCover },
    props: {

    },
    data() {
        return {
          rewardTitles: [
            '<p>九三学社</p><p>王选关怀基金会</p>',
            '<p>中国计算机学会</p><p>“CCF王选奖”</p>',
            '<p>中国新闻技术工作者联合会</p><p>“王选新闻科学技术奖”</p>',
            '<p>中国工业与应用数学学会</p><p>“王选应用数学奖”</p>'
          ],

          titleStyle: null,
          textMode: false,

          channelAlias: 'jinianjiangxiang',
          awardList: [],
          primaryRewardList: [],
        };
      },
    methods: {
      getAwardData(){
        getAwardList(this.channelAlias).then(result => {       
            this.awardList = [];             
            if(result.code != 0 || result.data == null){                
                return;
            }
            //this.awardList = result.data;   
            result.data.forEach(element => {
              if(element.title.indexOf('王选杰出青年学者') >= 0 || element.title.indexOf('王选青年学者') >= 0){
                this.primaryRewardList.push(element);
              }else{
                this.awardList.push(element);
              }
            });    
        });
      },
      onResize(){
        //let screenW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        let screenW = document.documentElement.clientWidth;
        if(screenW < 768){
          this.textMode = true;
        }else{
          this.textMode = false;
        }

        if(screenW < 1000){
          this.titleStyle = "font-size:16px;font-weight:normal;line-height:16px;";
        }else{
          this.titleStyle = null;
        }
      },

      handleItemClick(){
        this.$router.push({
          path: '/xuanchuan?tab=jinianjiangxiang'
        });
      }
    },
    created(){
        window.addEventListener('resize', this.onResize);
        this.getAwardData();
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize);
    },
    mounted(){
        this.$nextTick(()=>{
            this.onResize();
        });
    },
  };
</script>

<style scoped>
.rewards-block-wrap{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;  
  padding: 0px 24px;
  /*gap: 20px;*/
  flex-grow: 1;
  background: #FFFFFF;
  box-sizing: border-box;
}

.data-box{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    padding: 40px 0px;
    /*gap: 30px;*/
    flex-grow: 1;    
    box-sizing: border-box;    
    margin-left: 20px;
  }

  .left-box{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 34px 0px;
    /*gap: 24px;*/
    background: url('~@/assets/img/bg-pu.png') no-repeat, linear-gradient(126deg, #815119 8%, #EDC8AB 101%);
    background-size: auto 120%;
    background-position: center center;
    box-sizing: border-box;
    flex: 0 0 33.33%;
    height: 320px;
    cursor: pointer;
    margin-right: 30px;
  }
  .left-box:hover{
    opacity: 0.9;
  }
  .qn-icon-box{
    width: 120px;
    height: 120px;
    box-sizing: border-box;
    border: 2px solid #FFFFFF;
    border-radius: 100%;
  }
  .wx-img{
    width: 100%;
    height: 100%;
    background: url('~@/assets/icons/svg/wx-logo-brown.svg') no-repeat;
    background-size: cover;
  }
  .qn-title{
    font-size: 20px;
    font-weight: bold;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0em;
    color: #FFFFFF;
    margin-top: 24px;
  }

  .right-box{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    padding: 0px;
    /*gap: 30px;*/
    flex-grow: 1;
    box-sizing: border-box;    
    height: 100%;
  }
  .right-box .row{    
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    padding: 0px;
    /*gap: 30px;*/
    flex-grow: 1;
    align-self: stretch;   
    box-sizing: border-box;
  }
  .right-box .row:last-child{
    margin-top: 30px;
  }
  .right-box .row>div:last-child{
    margin-left: 30px;
  }
  .reward-item{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 0px;
    width: 100%;
    background: linear-gradient(90deg, #815119 0%, #B98F66 100%);    
  }
  .reward-item .title{
    font-size: 12px;
    font-weight: bold;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.1em;
    background: linear-gradient(180deg, #FFFBED 0%, #F9E29C 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    text-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.6);
  }
  .r-item{
    width: 420px;
    height: 145px;
    box-sizing: border-box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .reward-img:hover{
    opacity: 0.8;
  }
  @media screen and (max-width: 1000px){
      .rewards-block-wrap{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        padding: 0px 10px;
        gap: 12px;   
        background: #D8DCE2;     
      }
      .data-box{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0px;
        /*gap: 20px;*/
        margin-left: 0px;        
      }
      .left-box{
        margin-right: 0px;
        margin-bottom: 20px;
        /*gap: 20px;*/
      }
      .qn-title{
        margin-top: 20px;
      }

  }
  @media screen and (max-width: 1000px){
    /*
    .data-box{        
        gap: 10px;
    }
    */
    .left-box{
      margin-bottom: 10px;
    }
    
    .qn-title{
        margin-top: 10px;
      }
    .right-box{
      /*gap: 10px;*/
    }
    .right-box .row{
      /*gap: 10px;*/
    }
    .right-box .row:last-child{
      margin-top: 10px;
    }
    .right-box .row>div:last-child{
      margin-left: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/blocks/memoryblock/rewardsblock.vue